import { render, staticRenderFns } from "./TemplateColumn.vue?vue&type=template&id=7d743cae&scoped=true&xmlns%3Av=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TemplateColumn.vue?vue&type=script&lang=js&"
export * from "./TemplateColumn.vue?vue&type=script&lang=js&"
import style0 from "../Style/template-column.scss?vue&type=style&index=0&id=7d743cae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d743cae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d743cae')) {
      api.createRecord('7d743cae', component.options)
    } else {
      api.reload('7d743cae', component.options)
    }
    module.hot.accept("./TemplateColumn.vue?vue&type=template&id=7d743cae&scoped=true&xmlns%3Av=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('7d743cae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/TemplateColumn.vue"
export default component.exports